import axios from 'src/utils/axios';
import { AxiosResponse } from 'axios';
import { RentersDashboardCertification } from 'src/types/Certification';

export default class RentersDashboardService {
  public static fetchRentersCertifications = async (
    params: string
  ): Promise<AxiosResponse<RentersDashboardCertification[]>> => {
    return axios.get(`/renters_dashboard/${params}`);
  };
  public static fetchRentersCertificationsFilters = async (
    params: string
  ): Promise<AxiosResponse<unknown>> => {
    return axios.get(`/renters_dashboard_filters/${params}`);
  };
}
